<template>
  <div class="teac_bg">
    <div>
      <header>
        <el-image :src="iconHeader"></el-image>
        <span class="title_font" @click="goBack()">{{ titleName }}</span>
      </header>
      <div class="title_line"></div>
      <body>
        <div v-if="videoInfo.infoList.length">
          <div class="list_bg" v-if="isShowList">
            <div
              class="item_video_bg t-h"
              v-for="(item, index) in videoInfo.infoList"
              :key="index"
              @click="goItemVideo(item)"
            >
              <el-image :src="item.vtFmimg" class="video_bg_one">
                <div slot="error">
                  <el-image :src="defaultImg"> </el-image></div
              ></el-image>
              <p>{{ item.vtTitle }}</p>
              <div class="line_two"></div>
            </div>
          </div>
          <div style="text-align: center; margin-top: 8px">
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="pageParams.pageSize"
              layout="prev, pager, next"
              :total="videoInfo.total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-else>
          <div style="font-size:18px;margin:20px 0;text-indent:44px;">敬请期待...</div>
        </div>

        <div v-show="isShowContent">
          <div id="J_prismPlayer"></div>
        </div>
      </body>
    </div>
  </div>
</template>

<script>
import { getVideoList, getVideoDetail, getVideoAddress, setBrowerecord } from "@/network/api";

export default {
  data() {
    return {
      defaultImg: require("@/assets/images/defalut_icon.png"),
      iconHeader: require("@/assets/images/pageico_3.png"),
      isShowContent: false,
      isShowList: true,
      titleName: "教学视频",
      flashPlayer: "",
      videoInfo: {
        infoList: [],
        total: 0,
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    let videoId = this.$route.query.videoInfo;
    if (videoId == undefined) {
      this.initData();
    } else {
      this.startViedo(videoId, "搜索视频");
    }
  },
  methods: {
    goItemVideo(item) {
      setBrowerecord('videoteaching', item.id)
      getVideoDetail(item.id).then((res) => {
        if (res.code == 200) {
          this.startViedo(res.data.videoId, item.vtTitle);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    goBack() {
      this.videoInfo.infoList = [];
      this.videoInfo.total = 0;
      this.initData();
      this.isShowContent = false;
      this.isShowList = true;
      this.titleName = "教学视频";
      this.flashPlayer.dispose();
    },
    initData: function () {
      getVideoList(this.pageParams).then((res) => {
        this.videoInfo.infoList = res.rows;
        this.videoInfo.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.pageParams.pageNum = val;
      this.initData();
    },
    startViedo(videoId, vtTitle) {
      getVideoAddress(videoId).then((info) => {
        if (info.code == 200) {
          console.log(info, 111111)
          this.isShowContent = true;
          this.isShowList = false;
          this.titleName = "教学视频 | " + vtTitle + " |【返回】";
          var player = new Aliplayer(
            {
              id: "J_prismPlayer",
              source: info.data[0],
            },
            function (player) {
              console.log("The player is created.");
            }
          );
          this.flashPlayer = player;
        } else {
          this.$message.error(info.msg);
        }
      });
    },
  },
};
</script>


<style scoped>
.teac_bg {
  display: flex;
  justify-content: center;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
}
.list_bg {
  display: flex;
  flex-wrap: wrap;
}
.item_video_bg {
  margin-left: 12px;
  text-align: center;
}
.item_video_bg p {
  text-align: center;
  font-size: 16px;
  color: #353535;
  font-weight: bold;
}
p {
  text-align: left;
  text-indent: 24px;
  font-size: 16px;
  color: #787878;
  line-height: 24px;
}
.title_line {
  padding: 0;
  height: 1px;
  background-color: #b7b7b7;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
}
.line_two {
  border-bottom: 1px dashed #e2e2e2;
  margin-top: 6px;
}
.video_bg_one {
  width: 356px;
  height: 263px;
  text-align: center;
  margin: 0 auto;
}
.t-h:hover {
  color: #397b3e;
  cursor: pointer;
}
.t-h:hover p {
  color: #397b3e;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/TeachVideo.vue